module.exports = __webpack_public_path__ + "img/mirka-accounting2.6c5473f9.png";